import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=88624570&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=88624570&lang=scss&scoped=true"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=88624570&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88624570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88624570')) {
      api.createRecord('88624570', component.options)
    } else {
      api.reload('88624570', component.options)
    }
    module.hot.accept("./ChatMessage.vue?vue&type=template&id=88624570&scoped=true", function () {
      api.rerender('88624570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatMessage.vue"
export default component.exports